<template>
  <router-link class="link-u-reverse" v-if="getLink.linktype === 'story' && getLink.cached_url" :to="resolveSlug">
    <slot />
  </router-link>
  <a
    class="link-u-reverse"
    :href="'mailto:' + getLink.email"
    :target="getLink.target"
    v-else-if="getLink.linktype === 'email' && getLink.email"
  >
    <slot />
  </a>
  <a class="link-u-reverse" :href="getLink.url" v-else-if="getLink.url" :target="getLink.target">
    <slot />
  </a>
</template>
<script>
import prebuildConfig from "@/auto-generated/prebuild-config.json";

//.startsWith('http') ? getLink.url : 'https://' + getLink.url
export default {
  name: "SbLink",
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getLink() {
      const linktype = this.blok.attrs.linktype;
      const href = this.blok.attrs.href;
      const target = this.blok.attrs.target;

      let link = {};
      if (linktype === "story") {
        link["linktype"] = linktype;
        link["cached_url"] = href;
      } else if (linktype === "email") {
        link["linktype"] = linktype;
        link["email"] = href;
        link["target"] = target;
      } else {
        link["linktype"] = "url";
        link["url"] = href.startsWith("http") ? href : "https://" + href;
        link["target"] = target;
      }
      return link;
    },
    resolveSlug() {
      if (!this.getLink.linktype === "story") return true;
      let slug = this.getLink.cached_url;
      if (slug === `/${prebuildConfig.root_page_slug}`) {
        slug = "/";
      }
      return slug;
    },
  },
};
</script>
